import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";

export interface ComisionManualItem {
  id: number;
  idCotizacion: number;
  folioFactura: string;
  importe: number;
  idEmpleado: number;
  numeroEmpleado: string;
  empleado: string;
  tipo: string;
  montoComision: number;
  idClub: number;
  club: string;
  idConceptoNomina: number;
  conceptoNomina: string;
  descripcion: string;
  fechaPago: string;
  idArchivoMaquila: number;
  extra: boolean;
}

export interface ComisionManualCarga {
  comisiones: any[];
  totalRegistros: number;
  registrosExitosos: number;
  registrosConError: number;
  resultado: string;
  mensaje: string;
}

export interface GetComisionesManualExtras {
  comisionesManualExtras: ComisionManualItem[];
  gettingComisionesManualExtras: boolean;
  gettingComisionesManualExtrasError: any;
}

export interface PostComisionManualExcel {
  comisionManualCarga: ComisionManualCarga;
  postingComisionManualExcel: boolean;
  postingComisionManualExcelError: any;
}

export interface DeleteComisionManual {
  deletingComisionManual: boolean;
  deletingComisionManualError: any;
}

export interface State
  extends GetComisionesManualExtras,
    PostComisionManualExcel,
    DeleteComisionManual {}

const initialState: State = {
  comisionesManualExtras: [],
  gettingComisionesManualExtras: false,
  gettingComisionesManualExtrasError: null,
  comisionManualCarga: null,
  postingComisionManualExcel: false,
  postingComisionManualExcelError: null,
  deletingComisionManual: false,
  deletingComisionManualError: null
};

export default function comisionManualReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case actionTypes.CLEAR_COMISIONES_MANUALES_EXTRAS:
      return {
        comisionesManualExtras: null,
        comisionManualCarga: null
      };

    case `${actionTypes.GET_COMISIONES_MANUALES_EXTRAS}_PENDING`:
      return {
        comisionesManualExtras: null,
        gettingComisionesManualExtras: true,
        gettingComisionesManualExtrasError: null
      };

    case `${actionTypes.GET_COMISIONES_MANUALES_EXTRAS}_REJECTED`:
      return {
        comisionesManualExtras: null,
        gettingComisionesManualExtras: false,
        gettingComisionesManualExtrasError: readMessageBack(action)
      };

    case `${actionTypes.GET_COMISIONES_MANUALES_EXTRAS}_FULFILLED`:
      return {
        comisionesManualExtras: action.payload.data,
        gettingComisionesManualExtras: false,
        gettingComisionesManualExtrasError: null
      };

    case `${actionTypes.POST_COMISION_MANUAL_EXCEL}_PENDING`:
      return {
        comisionManualCarga: null,
        postingComisionManualExcel: true,
        postingComisionManualExcelError: null
      };

    case `${actionTypes.POST_COMISION_MANUAL_EXCEL}_REJECTED`:
      return {
        comisionManualCarga: null,
        postingComisionManualExcel: false,
        postingComisionManualExcelError: readMessageBack(action)
      };

    case `${actionTypes.POST_COMISION_MANUAL_EXCEL}_FULFILLED`:
      return {
        comisionManualCarga: action.payload.data,
        postingComisionManualExcel: false,
        postingComisionManualExcelError: null
      };

    case `${actionTypes.DELETE_COMISION_MANUAL}_PENDING`:
      return {
        deletingComisionManual: true,
        deletingComisionManualError: null
      };

    case `${actionTypes.DELETE_COMISION_MANUAL}_REJECTED`:
      return {
        deletingComisionManual: false,
        deletingComisionManualError: readMessageBack(action)
      };

    case `${actionTypes.DELETE_COMISION_MANUAL}_FULFILLED`:
      return {
        deletingComisionManual: false,
        deletingComisionManualError: null
      };

    default:
      return state;
  }
}
